export const TableSkeleton = ({ rows = 2, columns = 3 }) => {
  return (
    <div className='w-full overflow-x-auto'>
      <table className='min-w-full table-auto'>
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <th key={idx} className='px-4 py-2'>
                <div className='h-4 animate-pulse rounded bg-gray-300/10' />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            // eslint-disable-next-line react/no-array-index-key
            <tr key={rowIdx} className='border-b border-gray-200'>
              {Array.from({ length: columns }).map((_col, colIdx) => (
                // eslint-disable-next-line react/no-array-index-key
                <td key={colIdx} className='px-4 py-3'>
                  <div className='h-4 animate-pulse rounded bg-gray-200/10' />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
